import React, { useEffect, useRef } from 'react';
import "x-data-spreadsheet/dist/xspreadsheet.css";
import Spreadsheet from "x-data-spreadsheet";

export default function SpreadsheetViewer({ excelData, fileType, sheetName }) {
    const spreadsheetRef = useRef(null);
    const spreadsheetInstance = useRef(null);

    useEffect(() => {
        if(!fileType || !['csv','xlsx'].includes(fileType))
            return
        if (spreadsheetRef.current) {

            const maxRows = Object.keys(excelData).length;
            const maxCols = Math.max(
                ...Object.values(excelData).map(row => Object.keys(row.cells || {}).length)
            );

            // Initialize a new spreadsheet instance
            spreadsheetInstance.current = new Spreadsheet(spreadsheetRef.current,{mode: 'read', showToolbar:false, showContextmenu:false, row: {len: maxRows}, col: {len: maxCols}});

            // Load data if available
            if (excelData && Object.keys(excelData).length > 0) {
                spreadsheetInstance.current.loadData({
                            name: sheetName || 'Sheet1',
                            rows: excelData,
                        },
                );

            }
        }

        // Cleanup on unmount
        return () => {
            if (spreadsheetInstance.current) {
                if(spreadsheetRef.current)
                    spreadsheetRef.current.innerHTML = '';
                spreadsheetInstance.current = null;
            }
        };
    }, [excelData, sheetName]);

    return (
        <div
            ref={spreadsheetRef}
            style={{ overflowX: 'auto', overflowY: 'hidden', width: '100%', whiteSpace: 'nowrap' }}
        ></div>
    );
}